import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import type {
    AppQuippyScopePickerAdapter as AppQuippyScopePickerContract,
    AppQuippyScopeSelection,
} from '@quipex/feature/app-quippy';
import {
    BuildingScopePicker,
    type BuildingScopeSelection,
} from '@quipex/feature/buildings-find/scope-picker';

/** Building UI adapter provided at the app composition root. */
@Component({
    selector: 'qpx-app-quippy-scope-picker',
    imports: [BuildingScopePicker],
    template: `
        <qpx-building-scope-picker
            [selection]="selection()"
            (selectionChange)="changeSelection($event)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppQuippyScopePickerAdapter implements AppQuippyScopePickerContract {
    public readonly selection = input.required<AppQuippyScopeSelection>();
    public readonly selectionChange = output<AppQuippyScopeSelection>();

    protected changeSelection(selection: BuildingScopeSelection): void {
        this.selectionChange.emit(selection);
    }
}
